import { useEffect, useRef, useState } from "react";
import style from "./Notifications.module.scss";
import cn from "classnames";

export function Notifications() {
    const [notifications, setNotifications] = useState([
        {
            id: 1,
            read: false,
            date: "14.11.24 08:03:09",
            title: "Ми провели масштабне оновлення особистого кабінету!",
            content: `
                Сортування проксі: тепер можна впорядковувати проксі за терміном дії та датою покупки;
                Пошук проксі: легко знайдіть потрібні проксі за логіном або тегом;
                Також додали повідомлення (колокольчик біля ID) про актуальні оновлення сервісу.
                Чекаємо Ваш фідбек на сапорті
            `
        },
        {
            id: 2,
            read: false,
            date: "14.11.24 08:03:09",
            title: "Ми провели масштабне оновлення особистого кабінету!",
            content: `
                Сортування проксі: тепер можна впорядковувати проксі за терміном дії та датою покупки;
                Пошук проксі: легко знайдіть потрібні проксі за логіном або тегом;
                Також додали повідомлення (колокольчик біля ID) про актуальні оновлення сервісу.
                Чекаємо Ваш фідбек на сапорті
            `
        },
        {
            id: 3,
            read: true,
            date: "14.11.24 08:03:09",
            title: "Ми провели масштабне оновлення особистого кабінету!",
            content: `
                Сортування проксі: тепер можна впорядковувати проксі за терміном дії та датою покупки;
                Пошук проксі: легко знайдіть потрібні проксі за логіном або тегом;
                Також додали повідомлення (колокольчик біля ID) про актуальні оновлення сервісу.
                Чекаємо Ваш фідбек на сапорті
            `
        },
    ]);

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<"read" | "not read">("not read");

    const refContainer = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        function handleClick(e: any) {
            if (!refContainer.current?.contains(e.target)) {
                setIsOpen(false);
            }
        }

        document.documentElement.addEventListener("click", handleClick);

        return () => {
            document.documentElement.removeEventListener("click", handleClick);
        };
    }, []);

    return (
        <div ref={refContainer} className={cn(style.container, isOpen && style.container_open)}>
            <button
                className={style.button}
                onClick={() => {
                    setIsOpen(state => !state);
                }}
            >
                <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8851 10.4945L12.9772 8.94602C12.7764 8.60833 12.5996 7.95766 12.5996 7.56231V6.02209C12.5996 3.03228 10.2294 0.602539 7.3208 0.602539C4.40423 0.610775 2.034 3.03228 2.034 6.02209V7.55407C2.034 7.94942 1.85724 8.60009 1.66441 8.93779L0.756486 10.4862C0.410994 11.0875 0.330648 11.7711 0.547584 12.3641C0.764521 12.9654 1.25464 13.4431 1.89741 13.6572C2.76516 13.9538 3.64094 14.1679 4.53279 14.3244C4.62117 14.3409 4.70955 14.3491 4.79793 14.3656C4.91042 14.382 5.03094 14.3985 5.15146 14.415C5.36036 14.4479 5.56926 14.4726 5.78618 14.4891C6.29236 14.5385 6.80658 14.5632 7.3208 14.5632C7.82699 14.5632 8.33317 14.5385 8.83132 14.4891C9.01612 14.4726 9.20092 14.4562 9.37768 14.4315C9.5223 14.415 9.66693 14.3985 9.81155 14.3738C9.89993 14.3656 9.98832 14.3491 10.0767 14.3326C10.9766 14.1844 11.8684 13.9538 12.7362 13.6572C13.3548 13.4431 13.8289 12.9654 14.0539 12.3559C14.2788 11.7382 14.2146 11.0628 13.8851 10.4945ZM7.90733 7.15049C7.90733 7.49642 7.63415 7.77646 7.2967 7.77646C6.95924 7.77646 6.68606 7.49642 6.68606 7.15049V4.59719C6.68606 4.25126 6.95924 3.97122 7.2967 3.97122C7.63415 3.97122 7.90733 4.25126 7.90733 4.59719V7.15049Z" fill="#1E3755" />
                    <path d="M9.57916 15.3945C9.2417 16.3499 8.34985 17.0335 7.30534 17.0335C6.6706 17.0335 6.04389 16.7699 5.60198 16.3005C5.34487 16.0534 5.15204 15.7239 5.03955 15.3862C5.144 15.4027 5.24845 15.4109 5.36094 15.4274C5.54574 15.4521 5.73858 15.4768 5.93141 15.4933C6.38939 15.5345 6.8554 15.5592 7.32141 15.5592C7.77939 15.5592 8.23736 15.5345 8.68731 15.4933C8.85603 15.4768 9.02476 15.4686 9.18546 15.4439C9.31401 15.4274 9.44257 15.4109 9.57916 15.3945Z" fill="#1E3755" />
                </svg>
                <div className={style.counter}>
                    {notifications.filter(item => !item.read).length}
                </div>
            </button>
            <div className={style.notificationsManager}>
                <p className={style.managerLabel}>Повідомлення</p>
                <div className={style.divider}></div>
                <div className={style.tabsButtons}>
                    <button
                        className={cn(activeTab === "not read" && style.active)}
                        onClick={() => {
                            setActiveTab("not read")
                        }}
                    >
                        <p>Не прочитані: <span>{notifications.filter(item => !item.read).length}</span> </p>
                    </button>
                    <button
                        className={cn(activeTab === "read" && style.active)}
                        onClick={() => {
                            setActiveTab("read")
                        }}
                    >
                        <p>Прочитані: <span>{notifications.filter(item => item.read).length}</span> </p>
                    </button>
                </div>
                {
                    activeTab === "not read"
                        ? <div data-scrollable className={style.tabContent}>
                            {notifications.map(item => {
                                if (!item.read) {
                                    return (
                                        <Notification key={item.id} data={item} />
                                    )
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                        : null
                }
                {
                    activeTab === "read"
                        ? <div data-scrollable className={style.tabContent}>
                            {notifications.map(item => {
                                if (item.read) {
                                    return (
                                        <Notification key={item.id} data={item} />
                                    )
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                        : null
                }
            </div>
        </div>
    )
}

function Notification({
    data
}: {
    data: {
        id: number;
        read: boolean;
        date: string;
        title: string;
        content: string;
    }
}) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <div className={cn(style.notification, isOpen && style.notification_open)}>
            <div className="flex justify-between mb-[15px]">
                <p className={style.date}>{data.date}</p>
                <div className={style.actions}>
                    <button>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2 8L4.48699 10.8494C4.81675 11.0915 5.28286 11.0361 5.54388 10.7239L12 3" stroke="#A2AFD0" strokeWidth="1.4" strokeLinecap="round" />
                        </svg>
                    </button>
                    <button>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M5.104 6.42529V10.3691" stroke="#A2AFD0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M7.729 6.42529V10.3691" stroke="#A2AFD0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M1.1665 3.7959H11.6665" stroke="#A2AFD0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2.47949 3.7959H6.41699H10.3545V11.0262C10.3545 12.1152 9.47308 12.9981 8.38574 12.9981H4.44824C3.36093 12.9981 2.47949 12.1152 2.47949 11.0262V3.7959Z" stroke="#A2AFD0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.44775 2.4811C4.44775 1.75507 5.03538 1.1665 5.76025 1.1665H7.07275C7.79764 1.1665 8.38525 1.75507 8.38525 2.4811V3.79569H4.44775V2.4811Z" stroke="#A2AFD0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <button
                        onClick={() => {
                            setIsOpen(state => !state);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <g clipPath="url(#clip0_2303_42)">
                                <path d="M6.42253 11.0776C6.74146 11.3966 7.25854 11.3966 7.57747 11.0776L12.7747 5.8804C13.0936 5.56147 13.0936 5.04439 12.7747 4.72546C12.4558 4.40653 11.9387 4.40653 11.6198 4.72546L7 9.34522L2.38024 4.72546C2.06131 4.40653 1.54423 4.40653 1.2253 4.72546C0.906369 5.04439 0.90637 5.56147 1.2253 5.8804L6.42253 11.0776ZM6.18333 9.3335L6.18333 10.5002L7.81667 10.5002L7.81667 9.3335L6.18333 9.3335Z" fill="#A2AFD0" />
                            </g>
                            <defs>
                                <clipPath id="clip0_2303_42">
                                    <rect width="14" height="14" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            </div>
            <p className={style.title}>{data.title}</p>
            <p className={style.content}>
                {data.content}
            </p>
        </div>
    )
}